import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "cdes-page" }
const _hoisted_2 = { class: "ms-3" }
const _hoisted_3 = { class: "d-flex flex-row flex-wrap align-items-center" }
const _hoisted_4 = { class: "pageCaption ps-2" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border ms-2",
  role: "status"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "mt-4 mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "numberOfItemsLabel" }
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "d-flex flex-row" }
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = { class: "d-flex flex-row mt-4 mb-4" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressOutput = _resolveComponent("AddressOutput")!
  const _component_PlotTaskItemListWidget = _resolveComponent("PlotTaskItemListWidget")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_PasswordDialog = _resolveComponent("PasswordDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (this.onsubmit && this.onsubmit(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("plot.task.pageCaption")), 1),
          (this.loadingPdf)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: this.disabled,
                class: "btn btn-sm btn-outline-secondary ms-3",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('general.export.pdf'),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.exportToPdf()), ["prevent"]))
              }, _hoisted_10, 8, _hoisted_8))
        ]),
        _createElementVNode("b", null, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_AddressOutput, {
              address: this.billingAddress
            }, null, 8, ["address"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_AddressOutput, {
              address: this.plotterAddress
            }, null, 8, ["address"])
          ]),
          _createElementVNode("div", null, _toDisplayString(this.networkString), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(this.projectString), 1)
        ]),
        _createElementVNode("div", null, _toDisplayString(this.createdString), 1),
        _createElementVNode("div", null, _toDisplayString(this.clientCodeString), 1),
        _createElementVNode("b", null, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(this.jobNumberString), 1)
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("plot.task.positionCaption")), 1),
        _createVNode(_component_PlotTaskItemListWidget, {
          disabled: this.disabled,
          items: this.items,
          mode: this.mode
        }, null, 8, ["disabled", "items", "mode"]),
        _createElementVNode("div", _hoisted_15, _toDisplayString(this.numberOfItemsString), 1),
        _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("plot.task.areaSums")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(this.monochromeAreaSumLabel) + " " + _toDisplayString(this.colorAreaSumLabel) + " " + _toDisplayString(this.likeTemplateAreaSumLabel), 1),
          _createElementVNode("li", null, _toDisplayString(this.paperQualityAreaSumLabel), 1),
          _createElementVNode("li", null, _toDisplayString(this.plotMarginAreaSumLabel), 1),
          _createElementVNode("li", null, _toDisplayString(this.totalAreaSumLabel), 1)
        ]),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("plot.task.billingAddressLabel")), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("plot.task.deliveryDateLabel")), 1),
        _createElementVNode("div", null, _toDisplayString(this.kindOfDeliveryLabel), 1),
        _createElementVNode("div", null, _toDisplayString(this.commentLabel), 1),
        _createElementVNode("h3", _hoisted_17, _toDisplayString(this.resultCaption), 1),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_TextInput, {
            class: "flex-grow-1",
            label: _ctx.$t("plot.task.commentLabel"),
            disabled: false,
            tag: "textarea",
            mode: "flex",
            modelValue: this.comment,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.comment) = $event))
          }, null, 8, ["label", "modelValue"]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_RadioButton, {
              disabled: this.disabled,
              mode: "flex",
              name: "plotTaskPageResult",
              value: "accepted",
              label: this.acceptedLabel,
              selected: this.result,
              "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => ((this.result) = $event))
            }, null, 8, ["disabled", "label", "selected"]),
            _createVNode(_component_RadioButton, {
              disabled: this.disabled,
              mode: "flex",
              name: "plotTaskPageResult",
              value: "declined",
              label: this.declinedLabel,
              selected: this.result,
              "onUpdate:selected": _cache[3] || (_cache[3] = ($event: any) => ((this.result) = $event))
            }, null, 8, ["disabled", "label", "selected"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (this.mode == 'ReviewCyclePlotTask' && this.taskInfo!=null && this.taskInfo.acceptanceStep.finished == null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: this.disabled,
                ref: "reviewCyclePlotLaterButton",
                type: "submit",
                class: "btn btn-primary me-4"
              }, _toDisplayString(_ctx.$t('plot.task.laterButtonCaption')), 9, _hoisted_21))
            : _createCommentVNode("", true),
          (this.mode == 'PlotOrderAcceptanceTask')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: this.disabled,
                ref: "plotOrderAcceptanceAcceptButton",
                type: "submit",
                class: "btn btn-primary ms-4 me-4"
              }, _toDisplayString(_ctx.$t('plot.task.acceptanceButtonCaption')), 9, _hoisted_22))
            : _createCommentVNode("", true),
          (this.mode == 'ReviewCyclePlotTask')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                disabled: this.disabled,
                ref: "reviewCyclePlotNowButton",
                type: "submit",
                class: "btn btn-primary ms-4 me-4"
              }, _toDisplayString(this.taskInfo!=null&&this.taskInfo.acceptanceStep.finished == null?_ctx.$t('plot.task.nowButtonCaption'):_ctx.$t('plot.task.finishButtonCaption')), 9, _hoisted_23))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary ms-4",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.abort()))
          }, _toDisplayString(_ctx.$t('general.cancel')), 1)
        ])
      ])
    ], 32),
    _createVNode(_component_PasswordDialog, {
      ref: "passwordDialog",
      submitLabel: _ctx.$t('general.sign'),
      title: this.signDialogCaption
    }, null, 8, ["submitLabel", "title"])
  ]))
}